import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-178d4601"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-div"
}
const _hoisted_2 = {
  key: 1,
  class: "abilities-div"
}
const _hoisted_3 = {
  key: 2,
  class: "error-loading"
}

import { useI18n } from "vue-i18n";
import { useDataStore } from "@/pinia/DataStore";
import { onBeforeMount, ref } from "vue";
import { AppwriteException, Models } from "appwrite";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BreedingRhombusSpinner } from "epic-spinners";


export default /*#__PURE__*/_defineComponent({
  __name: 'AbilitiesCard',
  setup(__props) {

const i18n = useI18n();
const data = useDataStore();
const refData = ref<Models.DocumentList<Models.Document>>({
  total: 0,
  documents: [],
});
const loaded = ref(false);
const errorLoading = ref(false);
onBeforeMount(async () => {
  await getAppwriteData();
});
async function getAppwriteData() {
  try {
    errorLoading.value = false;
    loaded.value = false;
    refData.value = await data.appwriteInstance.listAbilitiesGroup();
  } catch (e: AppwriteException | unknown) {
    if (e instanceof AppwriteException)
      console.error("Error retrieving Appwrite data");
    else console.error("Unknown error");
    errorLoading.value = true;
  }
  loaded.value = true;
}

return (_ctx: any,_cache: any) => {
  return (!loaded.value && !errorLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t("loadingAppwrite")), 1),
        _createVNode(_unref(BreedingRhombusSpinner), {
          "animation-duration": 2000,
          size: 65
        })
      ]))
    : (loaded.value && !errorLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", null, "🔧 " + _toDisplayString(_ctx.$t("abilities")) + " 💻", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refData.value.documents, (document) => {
            return (_openBlock(), _createElementBlock("div", {
              key: document.$id
            }, [
              _createElementVNode("h3", null, _toDisplayString(_unref(i18n).locale.value == "es-ES" ? document.group_es : document.group), 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(document.abilities, (ability) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: ability.$id
                  }, [
                    _createTextVNode(_toDisplayString(ability.technology) + " ", 1),
                    (ability.icon)
                      ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                          key: 0,
                          class: "icon",
                          icon: ['fab', ability.icon]
                        }, null, 8, ["icon"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ]))
      : (errorLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t("errorDataAppwrite")) + " ", 1),
            _createElementVNode("button", { onClick: getAppwriteData }, "Recargar")
          ]))
        : _createCommentVNode("", true)
}
}

})